import { parseGbeError } from './parse-gbe-error';

/**
 * Pulls the most informative human-readable string out of a GBE HttpErrorResponse.
 * Order of preference: `details.explanation` (most specific) → `errorMessage` → fallback.
 */
export function extractGbeErrorMessage(err: unknown, fallback: string): string {
  const httpError = err as { error?: unknown } | null | undefined;
  if (httpError == null || httpError.error == null) return fallback;

  const gbeError = parseGbeError(httpError);
  const explanation = (gbeError.details as { explanation?: unknown } | undefined)
    ?.explanation;
  if (typeof explanation === 'string' && explanation.length > 0) return explanation;
  if (gbeError.errorMessage && gbeError.errorMessage !== 'An unknown error occurred') {
    return gbeError.errorMessage;
  }
  return fallback;
}
